import React, { Component } from "react";
import * as s from "./CollectionCard.module.scss";
import { ISingleWordpressCollection } from "resource-centre-theme/src/models";
import { truncate } from "resource-centre-theme/src/libs/utils";
import {
  BackgroundImage,
  P,
  Overlay,
  DynamicLink,
} from "resource-centre-theme/src/views/shared/components";
import { Icons } from "resource-centre-theme/src/libs/assets";
import { inject, observer } from "mobx-react";
import {
  SectionsContainerStore,
  NavigationStore,
} from "resource-centre-theme/src/stores";
import { CopyLink } from "resource-centre-theme/src/views/shared/modals";
import { tx } from "resource-centre-theme/src/libs/i18n";

interface Props {
  collection: ISingleWordpressCollection;
  sectionsContainerStore?: SectionsContainerStore;
  navigationStore?: NavigationStore;
}

interface State {
  copyLinkOverlayOpen: boolean;
  informationOverlayOpen: boolean;
}

@inject("sectionsContainerStore", "navigationStore")
@observer
export class CollectionCard extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      copyLinkOverlayOpen: false,
      informationOverlayOpen: false,
    };
  }

  toggleLinkOverlay = (e) => {
    e.preventDefault();
    const { sectionsContainerStore } = this.props;
    const { copyLinkOverlayOpen } = this.state;
    this.setState({ copyLinkOverlayOpen: !copyLinkOverlayOpen });

    if (!copyLinkOverlayOpen) {
      sectionsContainerStore.setScrollPos();
    } else {
      sectionsContainerStore.resetScrollPos();
    }
  };

  toggleInformationOverlay = (e) => {
    e.preventDefault();
    const { sectionsContainerStore } = this.props;
    const { informationOverlayOpen } = this.state;
    this.setState({ informationOverlayOpen: !informationOverlayOpen });

    if (!informationOverlayOpen) {
      sectionsContainerStore.setScrollPos();
    } else {
      sectionsContainerStore.resetScrollPos();
    }
  };

  render() {
    const { collection, navigationStore } = this.props;
    const { location } = navigationStore;
    const { origin } = location;
    const { copyLinkOverlayOpen } = this.state;
    const { collectionThumbnail, collectionFields, link } = collection;
    const image = collectionThumbnail?.image;
    const { title, documents } = collectionFields;
    const numberOfDocuments = documents?.length;
    const classes = [s.CollectionCard];
    return (
      <div className={classes.join(" ")}>
        {copyLinkOverlayOpen && (
          <Overlay>
            <CopyLink
              toggleOverlay={this.toggleLinkOverlay}
              link={origin + link}
            />
          </Overlay>
        )}
        <div className={s.image}>
          <div className={s.corner}></div>
          <DynamicLink to={link}>
            <div className={s.overlay}>
              <div className={s.overlayTopRow}>
                <img
                  src={Icons.link_small_white}
                  className={s.linkButton}
                  onClick={this.toggleLinkOverlay}
                />
              </div>
              <div className={s.overlayBottomRow}></div>
            </div>
            {image && <BackgroundImage image={image} />}
          </DynamicLink>
        </div>
        <DynamicLink to={link}>
          {title && (
            <P medium className={s.title}>
              {truncate(title, 75)}
            </P>
          )}
          <div className={s.resourcesContainer}>
            <P className={s.resourcesInformationLabel}>
              {tx("collection.numberOfResourcesInCollection", {numberOfResources: numberOfDocuments})}
            </P>
            <P className={s.resourcesInformationLabel}>
              {tx("misc.curatedByIYCF")}
            </P>
          </div>
        </DynamicLink>
      </div>
    );
  }
}
